module.exports = __webpack_public_path__ + "0647dc3ab033b1e8f4d03d5777d723f3.svg";